var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-address-administration__list-view" },
    [
      _vm.$t("labels.addresses")
        ? _c("h3", [_vm._v(_vm._s(_vm.$t("labels.addresses")))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.addresses, function (address, key) {
          return key + 1 >= _vm.start && key + 1 <= _vm.end
            ? _c(
                "div",
                { key: key, staticClass: "col-12 col-md-6 col-lg-4" },
                [
                  address.mainAddress
                    ? [
                        _c(
                          "global-address",
                          { attrs: { address: address } },
                          [
                            _c(
                              "template",
                              { slot: "side-actions" },
                              [
                                _c("global-button", {
                                  attrs: {
                                    icon: "trash",
                                    theme: "ghost",
                                    disabled: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c("global-button", {
                                  attrs: {
                                    icon: "edit",
                                    theme: "ghost",
                                    disabled: "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "global-button",
                              {
                                attrs: { slot: "actions" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAddress(address.index)
                                  },
                                },
                                slot: "actions",
                              },
                              [_vm._v(_vm._s(_vm.$t("labels.select")))]
                            ),
                          ],
                          2
                        ),
                      ]
                    : [
                        _c(
                          "global-address",
                          { attrs: { address: address } },
                          [
                            _c(
                              "template",
                              { slot: "side-actions" },
                              [
                                _c("global-button", {
                                  attrs: { icon: "trash", theme: "ghost" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteAddress(address.index)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("global-button", {
                                  attrs: { icon: "edit", theme: "ghost" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editAddress(address.index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "global-button",
                              {
                                attrs: { slot: "actions" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAddress(address.index)
                                  },
                                },
                                slot: "actions",
                              },
                              [_vm._v(_vm._s(_vm.$t("labels.select")))]
                            ),
                          ],
                          2
                        ),
                      ],
                ],
                2
              )
            : _vm._e()
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }